import React, {Component} from 'react'
import PropTypes from 'prop-types'
import StatusStyle from '../../../../shared/StatusStyle'
import {Tooltip} from "antd"
import TagRequestUpdate from "./TagRequestUpdate"
import LazyLoad from 'react-lazyload'

class ItemStatus extends Component {
    render() {
        const {status, is_archive, auto_artwork_approve, cancelled_reason, safezone_warning, tags, orderId, marketplace, itemNumber, itemsRequest = [], lazyload, processing_at = ''} = this.props
        const reason = status === 'cancelled' ? cancelled_reason : ''
        const barcodeNumber = `#${marketplace}_${itemNumber}`
        const itemRequest = itemsRequest.filter(item => item.fac_barcode_number === barcodeNumber)

        return (
            <td className='ItemStatus'>
                {
                    lazyload ? 
                    <LazyLoad>

                        <StatusStyle status={status} note={reason} processing_at={processing_at}/>
                        {
                            !!is_archive &&
                            <div>
                                <StatusStyle status="archived"/>
                            </div>
                        }

                        {
                            !!safezone_warning && <div>
                                <Tooltip title={safezone_warning}>
                                    <span className="warning">Warning</span>
                                </Tooltip>
                            </div>
                        }

                        {
                            auto_artwork_approve !== undefined &&
                            <div>
                                <span className="badge autoApprove badge-pill">Auto Approve</span>
                            </div>
                        }

                        {
                            !!tags && tags.length > 0 &&
                            <div className="TagRequest">
                                {
                                    tags.map((tag, index) => {
                                        const itemRequestCurrent = itemRequest[index] || {}
                                        return <TagRequestUpdate tag={tag} orderId={orderId} key={index} itemRequest={itemRequestCurrent.content || ''}/>
                                    })
                                }
                            </div>
                        }
                    </LazyLoad> : 
                    <>
                        <StatusStyle status={status} note={reason} processing_at={processing_at}/>
                        {
                            !!is_archive &&
                            <div>
                                <StatusStyle status="archived"/>
                            </div>
                        }

                        {
                            !!safezone_warning && <div>
                                <Tooltip title={safezone_warning}>
                                    <span className="warning">Warning</span>
                                </Tooltip>
                            </div>
                        }

                        {
                            auto_artwork_approve !== undefined &&
                            <div>
                                <span className="badge autoApprove badge-pill">Auto Approve</span>
                            </div>
                        }

                        {
                            !!tags && tags.length > 0 &&
                            <div className="TagRequest">
                                {
                                    tags.map((tag, index) => {
                                        const itemRequestCurrent = itemRequest[index] || {}
                                        return <TagRequestUpdate tag={tag} orderId={orderId} key={index} itemRequest={itemRequestCurrent.content || ''}/>
                                    })
                                }
                            </div>
                        }
                    </>
                }
            </td>
        )
    }
}

ItemStatus.propTypes = {
    safezone_warning: PropTypes.string,
    status: PropTypes.string.isRequired,
    is_archive: PropTypes.bool,
}

export default ItemStatus
